import ModalCreateAddonConnect from '../../../../../app/erp/screens/Logistic/ProductsParent/Addons/ModalCreateAddon'
import ModalCreateProductConnect from '../../../../../app/erp/screens/Logistic/ProductsParent/Products/ModalCreateProduct'
import { UserPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { ITLayoutTableModalOpen } from '../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { InputTableURLsTable, InputTableLayoutData, OrderHeaderURLs } from '../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { BuildedOrder } from '../../../../../baseComponents/TwinTable/types'
import { TwinDictionary } from '../../../../../utils/globals/dictionary'
import { OnChangeOrderAddProduct } from '../../OrderLayout/OrderTable/TableComponents/Inputs/OrderSearchProductInput/types'
import ModalDeleteLineOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalDeleteLineOrder'
import ModalEditableTextProductOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalEditableTextProductOrder'
import ModalComplementProductOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalEditAddonProductOrder'
import ModalEditProductOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalEditProductOrder'
import ModalPriceProductOrder from '../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalPriceProductOrder'
import ModalAddDiscountOrder from '../../OrderLayout/OrderTotal/FooterOrderTotal/Components/ModalFinancialRowsOrder/ModalAddDiscountOrder'
import ModalAddRechargesOrder from '../../OrderLayout/OrderTotal/FooterOrderTotal/Components/ModalFinancialRowsOrder/ModalAddRechargeOrder'
import ModalComplexBuyProductOrderConnect from './ModalComplexBuyProductOrder'
import ModalConfigShippingBuyOrderCreateStepHeaderConnect from './ModalConfigShippingBuyOrder'
import ModalPrintSingleTagBuyConnect from './ModalPrintSingleTagBuy'
import ModalUniqueNumberProductBuyOrder from './ModalUniqueNumberProductBuyOrder'

interface ModalsOrderBuyLayoutProps {
    openModal: ITLayoutTableModalOpen
    setOpenModal: React.Dispatch<React.SetStateAction<ITLayoutTableModalOpen>>
    onChangeAdd: OnChangeOrderAddProduct
    onChangeUpdate: () => void
    deleteLine: (id: number) => void
    inputTableURLs: InputTableURLsTable
    userPermissions: UserPermissions
    headerData: TwinDictionary
    getCompleteData: (order?: BuildedOrder) => Promise<void>
    onChangeFetch: (rowIndex: number, keyValue: string, value: string) => Promise<void>
    completeData: InputTableLayoutData
    setCompleteData: React.Dispatch<React.SetStateAction<InputTableLayoutData | null>>
    isReadOnly?: boolean
    orderHeaderURLs: OrderHeaderURLs
}

const ModalsOrderBuyLayout: React.FC<ModalsOrderBuyLayoutProps> = ({ openModal, onChangeAdd, onChangeUpdate, onChangeFetch, deleteLine, setOpenModal, ...rest }) => {
    const typeDict: any = {
        editProduct: { component: ModalEditProductOrder, onSubmit: onChangeUpdate },
        priceProduct: { component: ModalPriceProductOrder, onSubmit: onChangeUpdate },
        deleteLine: { component: ModalDeleteLineOrder, onSubmit: () => deleteLine(openModal?.allRowData.id) },
        complexProduct: { component: ModalComplexBuyProductOrderConnect, onSubmit: () => deleteLine(openModal?.allRowData.line)},
        editableText: { component: ModalEditableTextProductOrder, onSubmit: (value: any) => onChangeFetch(openModal?.allRowData.absoluteIndex || openModal?.allRowData.rowIndex, openModal?.allRowData.dataKey, value) },
        editAddonProduct: { component: ModalComplementProductOrder, onSubmit: onChangeUpdate },
        uniqueNumber: { component: ModalUniqueNumberProductBuyOrder, onSubmit: onChangeUpdate },
        printTags: { component: ModalPrintSingleTagBuyConnect },
        configShipping: { component: ModalConfigShippingBuyOrderCreateStepHeaderConnect },
        addDiscount: { component: ModalAddDiscountOrder },
        addRecharge: { component: ModalAddRechargesOrder },
        createProduct: { component: ModalCreateProductConnect, onSubmit: openModal?.allRowData?.onSubmit },
        createComplement: { component: ModalCreateAddonConnect, onSubmit: openModal?.allRowData?.onSubmit }
    }
    if (openModal?.type && openModal.type in typeDict) {
        const element = typeDict[openModal.type]
        const Component = element.component
        const onSubmit = element.onSubmit
        return <Component allRowData={openModal.allRowData} {...rest} orderURLs={rest.inputTableURLs} onSubmit={onSubmit} setOpened={() => setOpenModal(null)} tableData={rest.completeData.tableData} navigateToProduct={false} />
    }
    return null
}

export default ModalsOrderBuyLayout